<template>
  <div class="dotacao" :class="{ 'dotacao-compact': compact }">
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part unidade-executora" v-bind="attrs" v-on="on">{{ dotacao.unidade_executora.codigo_unidade }}</span>
      </template>
      {{ dotacao.unidade_executora.nome }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part unidade-orcamentaria" v-bind="attrs" v-on="on">{{ dotacao.unidade_orcamentaria.codigo_unidade }}</span>
      </template>
      {{ dotacao.unidade_orcamentaria.nome }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part acao" v-bind="attrs" v-on="on">{{ formatCodigoFuncao(dotacao.acao.codigo_funcao ) }}</span>
      </template>
      {{ dotacao.acao.descricao_funcao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part subfuncao" v-bind="attrs" v-on="on">{{ dotacao.acao.codigo_sub_funcao }}</span>
      </template>
      {{ dotacao.acao.descricao_sub_funcao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part programa" v-bind="attrs" v-on="on">{{ formatCodigoPrograma(dotacao.programa.codigo_programa) }}</span>
      </template>
      {{ dotacao.programa.descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part acao" v-bind="attrs" v-on="on">{{ dotacao.acao.codigo_acao }}</span>
      </template>
      {{ dotacao.acao.descricao_acao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part subacao" v-bind="attrs" v-on="on">{{ formatCodigoSubAcao(dotacao.acao.codigo_sub_acao) }}</span>
      </template>
      {{ dotacao.acao.sub_acao_descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part grupo" v-bind="attrs" v-on="on">{{ dotacao.grupo.codigo_grupo }}</span>
      </template>
      {{ dotacao.grupo.descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part elemento" v-bind="attrs" v-on="on">{{ dotacao.elemento.codigo_elemento }}</span>
      </template>
      {{ dotacao.elemento.descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip" v-if="dotacao.elemento_item.codigo_elemento_item != 0">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part elemento-item" v-bind="attrs" v-on="on">{{ formatCodigoElementoItem(dotacao.elemento_item.codigo_elemento_item) }}</span>
      </template>
      {{ dotacao.elemento_item.descricao }}
    </v-tooltip>
    <span v-else class="dotacao-part elemento-item-placeholder"></span>{{ (dotacao.elemento_item.codigo_elemento_item != 0) ? "." : "." }}
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part fonte" v-bind="attrs" v-on="on">{{ dotacao.fonte.codigo_fonte }}</span>
      </template>
      {{ dotacao.fonte.descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part ipu" v-bind="attrs" v-on="on">{{ dotacao.ipu.codigo_ipu }}</span>
      </template>
      {{ dotacao.ipu.descricao }}
    </v-tooltip>.
    <v-tooltip bottom max-width="300" color="#1F2937" class="custom-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="dotacao-part ipg" v-bind="attrs" v-on="on">{{ dotacao.ipg.codigo_ipg }}</span>
      </template>
      {{ dotacao.ipg.descricao }}
    </v-tooltip>
    
  </div>
</template>

<script>
export default {
  name: "DotacaoConcatenada",
  props: {
    dotacao: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatCodigoPrograma(codigo) {
      return String(codigo).padStart(3, '0');
    },
    formatCodigoSubAcao(codigo) {
      return String(codigo).padStart(4, '0');
    },
    formatCodigoFuncao(codigo) {
      return String(codigo).padStart(2, '0');
    },
    formatCodigoElementoItem(codigo) {
      if (codigo != 0 && codigo < 10) {
        return String(codigo).padStart(2, '0');
      }
      return codigo;
    }
  }
};
</script>

<style scoped>
.dotacao {
  font-size: 15px; 
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  line-height: 1.4;
}

/* Modo compacto para uso em tabelas */
.dotacao-compact {
  font-size: 12px;
  font-weight: 500;
  justify-content: center;
}

.dotacao-compact .dotacao-part {
  width: auto;
  min-width: 35px;
  max-width: 70px;
  padding: 2px 4px;
  font-size: 11px;
  border-width: 1px;
}

.dotacao-part {
  margin-right: 0;
  padding: 3px 6px;
  border: 1px solid #374151;
  border-radius: 4px;
  width: 75px;
  text-align: center;
  transition: all 0.2s ease;
  cursor: help;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #F3F4F6;
  color: #1F2937;
}

.dotacao-part:hover {
  background-color: #E5E7EB;
  border-color: #16A34A;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dotacao-part.elemento-item-placeholder {
  width: 75px;
  margin-right: 0;
  padding: 3px 6px;
  border: 1px solid transparent;
  background-color: transparent;
}

.dotacao-compact .dotacao-part.elemento-item-placeholder {
  width: auto;
  min-width: 35px;
  max-width: 70px;
}

/* Mantém estilo neutro para todas as caixinhas - sem cores específicas */
.exercicio,
.unidade-executora,
.unidade-orcamentaria,
.acao,
.subfuncao,
.programa,
.subacao,
.grupo,
.elemento,
.elemento-item,
.ipg,
.fonte,
.ipu {
  /* Herdam o estilo padrão do .dotacao-part */
}

/* Responsividade */
@media (max-width: 768px) {
  .dotacao {
    font-size: 13px;
  }
  
  .dotacao-part {
    width: 60px;
    padding: 2px 4px;
    font-size: 11px;
  }
  
  .dotacao-compact {
    font-size: 10px;
  }
  
  .dotacao-compact .dotacao-part {
    min-width: 30px;
    max-width: 55px;
    padding: 1px 3px;
    font-size: 9px;
  }
}

@media (max-width: 480px) {
  .dotacao {
    font-size: 11px;
  }
  
  .dotacao-part {
    width: 50px;
    padding: 1px 3px;
    font-size: 10px;
  }
  
  .dotacao-compact .dotacao-part {
    min-width: 25px;
    max-width: 45px;
    font-size: 8px;
  }
}

/* Tooltip customizado */
:deep(.v-tooltip__content.custom-tooltip) {
  background-color: #1F2937 !important;
  color: #FFFFFF !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
</style>
